import { render } from "./Gegevens.vue?vue&type=template&id=1f01f4da&scoped=true"
import script from "./Gegevens.vue?vue&type=script&lang=js"
export * from "./Gegevens.vue?vue&type=script&lang=js"

import "./Gegevens.vue?vue&type=style&index=0&id=1f01f4da&scoped=true&lang=scss"

import exportComponent from "E:\\Old Files\\Projecten Web\\Q-Mobile\\frame\\q-mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f01f4da"]])

export default __exports__